package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_12_08_Day_1
import com.veldekar.components.logs.Log_2023_12_08_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-12-08")
@Composable
public fun Log_2023_12_08(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Disguises and Reports",
        ogTitle = "Disguises and Reports",
        date = LocalDate(2_023, 12, 8),
        ogDescription = "Falorn explains his desertion from The Fist, while the party encounters the Carnage Crew again in the city streets.",
        ogImage = "ai/2023-12-08.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-38", dateString = "Newgrowth 38")
        Log_2023_12_08_Day_1()
        SessionDayHeader(dayId = "newgrowth-39", dateString = "Newgrowth 39")
        Log_2023_12_08_Day_2()
    }
}
